import { Pipe, PipeTransform } from '@angular/core';

/** Formata telefone BR: (xx) xxxxx-xxxx (celular) ou (xx) xxxx-xxxx (fixo). Remove DDI 55 se presente. */
@Pipe({
  name: 'brPhoneFormat',
})
export class BrPhoneFormatPipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) {
      return '';
    }

    let digits = value.replace(/\D/g, '');
    if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
      digits = digits.slice(2);
    }

    if (digits.length === 11) {
      return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    if (digits.length === 10) {
      return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    return value;
  }
}
